import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import CSVImporter from '../../CSVImporter/CSVImporter';

import AsyncCreatableSelect from 'react-select/async-creatable';
import { components } from 'react-select';
var _ = require('lodash');

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
const axios = require('axios').default;
import { toast } from 'react-toastify';

import {
  offsetDateForServer
} from '../../../shared/timeZoneLogic';
import ArtistChipsField from '../../shared/components/ArtistChipsField';

const CustomMenuList = (props) => {
  const { inputValue, onCreateOption } = props.selectProps;
  if (!inputValue) {
    return <components.MenuList {...props} />;
  }

  return (
    <div>
      <components.MenuList {...props} />
      <div
        className="text-left"
        style={{
          padding: '12px',
          cursor: 'pointer',
        }}
      >
        <div className="lined-text"
              style={{
                textAlign: 'center',
                fontSize: '14px',
                color: '#535862',
                marginBottom: '8px'
              }}>
          Venue not listed?
        </div>
        <a className='text-dark'
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onCreateOption(inputValue);
            }}
            style={{fontSize: '16px'}}>
          + Add new venue
        </a>
      </div>
    </div>
  );
};

const selectStyles = {
  container: (base, state) => ({
    ...base,
    opacity: state.isDisabled ? ".5" : "1",
    backgroundColor: "transparent",
    zIndex: "999"
  }),
  control: (base, state) => ({
    ...base,
    borderRadius: "8px",
    fontSize: "16px"
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: provided => ({ ...provided, zIndex: "9999 !important" })
};

const formatDateTime = (date) => {
  if (!date) return "";
  const options = { 
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };
  return new Date(date).toLocaleString('en-US', options);
};

const isValidUrl = (url) => {
  if (!url) return false;
  try {
    new URL(url);
    return url.startsWith('http://') || url.startsWith('https://');
  } catch (e) {
    return false;
  }
};

const formatVenueLabel = (option, { context }) => {
  if (context === 'value') {
    return option.name || option.label;
  }

  return (
    <div className='d-flex align-items-center' style={{width: '100%', fontSize: '16px'}}>
      <div className="text-truncate" style={{ minWidth: 0 }}>
        {option.name || option.label}
      </div>
      {(option.city || option.country_code) && (
        <div className="text-muted"
              style={{marginLeft: '9px', flexShrink: 0}}>
          {[option.city, option.country_code].filter(Boolean).join(', ')}
        </div>
      )}
    </div>
  );
};

const debouncedFetch = _.debounce((inputValue, callback) => {
  new Promise(resolve => {
    axios.get('/venues/search', {
        params: {
          name: inputValue
        }
      })
      .then(({data}) => {
        var newOptions = data.map((d) => {
          return {
            ...d,
            value: d.id,
            label: d.name
          };
        });

        callback(newOptions);
      })
  });
}, 250);

const TourDateForm = ({
  csrfToken,
  team,
  currentUser,
  tour,
  tourDate,
  setTourDate,
  tourDates,
  tourDatesChanged,
  deleteTourDate
}) => {
  const [newVenue, setNewVenue] = useState(null);
  const [showAdditionalSettings, setShowAdditionalSettings] = useState(false);
  const [isCreatingVenue, setIsCreatingVenue] = useState(false);
  const [isCreatingVenueOwnership, setIsCreatingVenueOwnership] = useState(false);
  const [supportArtists, setSupportArtists] = useState([]);

  useEffect(() => {
    if (tourDate.support_performers && tourDate.support_performers.length > 0) {
      setSupportArtists(tourDate.support_performers.map(performer => ({
        value: performer.artistable.id,
        label: performer.artistable.name,
        image_thumb_url: performer.artistable.image_thumb_url,
        performer_id: performer.id
      })));
    } else {
      setSupportArtists([]);
    }
  }, [tourDate.support_performers, tourDate.id]);

  const canSaveNewVenue = (
    newVenue
      && newVenue.name
      && newVenue.name.length > 0
      && newVenue.address1
      && newVenue.address1.length > 0
      && newVenue.city
      && newVenue.city.length > 0
      && newVenue.state
      && newVenue.state.length > 0
      && newVenue.zip
      && newVenue.zip.length > 0
      && newVenue.country
      && newVenue.country.length > 0
  );

  const createVenue = () => {
    setIsCreatingVenue(true);
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.post(`/venues`, {
        venue: {
          name: newVenue.name,
          address1: newVenue.address1,
          city: newVenue.city,
          state_name: newVenue.state,
          zip: newVenue.zip,
          country_name: newVenue.country
        }
      })
      .then(({data}) => {
        setNewVenue(null);
        findOrCreateVenueOwnership(data);
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      })
      .finally(() => {
        setIsCreatingVenue(false);
      });
  };



  const canSaveTourDate = (
    tourDate
      && tourDate.name
      && tourDate.name.length > 0
      && tourDate.event_on
      && tourDate.venue_ownership_id
      && (
        !tourDate.presale_url
          || tourDate.presale_url.length === 0
          || isValidUrl(tourDate.presale_url)
      )
      && (
        !tourDate.public_on_sale_url
          || tourDate.public_on_sale_url.length === 0
          || isValidUrl(tourDate.public_on_sale_url)
      )
      && (
        !tourDate.vip_url
          || tourDate.vip_url.length === 0
          || isValidUrl(tourDate.vip_url)
      )
  );

  const createTourDate = (tourDate, onSuccess) => {
    const supportPerformersAttributes = supportArtists
      .filter(artist => artist && artist.value)
      .map(artist => ({
        artistable_id: artist.value,
        artistable_type: 'Artist',
        act_type: 'support'
      }));

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.post(`/teams/${team.id}/tours/${tour.id}/tour_dates`, {
        tour_date: {
          name: tourDate.name,
          event_on: tourDate.event_on?.toLocaleDateString('en-CA'),
          announce_at: offsetDateForServer(tourDate.announce_at),
          event_state: tourDate.event_state,
          enable_lottery: tourDate.enable_lottery,
          presale_start_at: offsetDateForServer(tourDate.presale_start_at),
          presale_end_at: offsetDateForServer(tourDate.presale_end_at),
          presale_code: tourDate.presale_code,
          presale_url: tourDate.presale_url,
          public_on_sale_start_at: offsetDateForServer(tourDate.public_on_sale_start_at),
          public_on_sale_end_at: offsetDateForServer(tourDate.public_on_sale_end_at),
          public_on_sale_url: tourDate.public_on_sale_url,
          vip_start_at: offsetDateForServer(tourDate.vip_start_at),
          vip_end_at: offsetDateForServer(tourDate.vip_end_at),
          vip_url: tourDate.vip_url,
          venue_ownership_id: tourDate.venue_ownership_id,
          support_performers_attributes: supportPerformersAttributes
        }
      })
      .then(({data}) => {
        tourDatesChanged([...tourDates, data]);
        onSuccess(data);
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  const updateTourDate = (tourDate, onSuccess) => {
    const supportPerformersAttributes = supportArtists
      .filter(artist => artist && artist.value)
      .map((artist) => {
        const attributes = {
          artistable_id: artist.value,
          artistable_type: 'Artist',
          act_type: 'support'
        };

        if (artist.performer_id) {
          attributes.id = artist.performer_id;
        }

        return attributes;
      });

    if (tourDate.support_performers) {
      const currentArtistIds = supportArtists.map(a => a && a.performer_id).filter(Boolean);
      tourDate.support_performers.forEach((performer) => {
        if (!currentArtistIds.includes(performer.id)) {
          supportPerformersAttributes.push({
            id: performer.id,
            _destroy: true
          });
        }
      });
    }

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.put(`/teams/${team.id}/tours/${tour.id}/tour_dates/${tourDate.id}`, {
        tour_date: {
          name: tourDate.name,
          event_on: tourDate.event_on?.toLocaleDateString('en-CA'),
          announce_at: offsetDateForServer(tourDate.announce_at),
          event_state: tourDate.event_state,
          enable_lottery: tourDate.enable_lottery,
          presale_start_at: offsetDateForServer(tourDate.presale_start_at),
          presale_end_at: offsetDateForServer(tourDate.presale_end_at),
          presale_code: tourDate.presale_code,
          presale_url: tourDate.presale_url,
          public_on_sale_start_at: offsetDateForServer(tourDate.public_on_sale_start_at),
          public_on_sale_end_at: offsetDateForServer(tourDate.public_on_sale_end_at),
          public_on_sale_url: tourDate.public_on_sale_url,
          vip_start_at: offsetDateForServer(tourDate.vip_start_at),
          vip_end_at: offsetDateForServer(tourDate.vip_end_at),
          vip_url: tourDate.vip_url,
          venue_ownership_id: tourDate.venue_ownership_id,
          support_performers_attributes: supportPerformersAttributes
        }
      })
      .then(({data}) => {
        tourDatesChanged([...tourDates].map(td => td.id === data.id ? data : td));
        onSuccess(data);
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  const findOrCreateVenueOwnership = (venue) => {
    setIsCreatingVenueOwnership(true);
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.post(`/teams/${team.id}/venue_ownerships/find_or_create`, {
        venueable_id: venue.id,
        venueable_type: "Venue"
      })
      .then(({data}) => {
        setTourDate({
          ...tourDate,
          venue_ownership: data,
          venue_ownership_id: data.id
        });

        gon.timeZone = data.tzinfo_identifier;
      })
      .catch((error) => {
        toast.error("Error adding venue", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      })
      .finally(() => {
        setIsCreatingVenueOwnership(false);
      });
  };

  return (
    <div>
      <div style={{
        marginTop: '16px',
        marginBottom: '20px',
        borderBottom: "1px solid #E9EAEB",
        paddingBottom: '24px'
      }}>
        <div className='row'>
          <div className='col-12 col-lg-6'>
            <p className="mb-0" style={{fontSize: '18px', fontWeight: '600'}}>
              Add Events
            </p>
            <p className="mb-0" style={{fontSize: '14px'}}>
              Input event data for each show on the tour.
            </p>
          </div>
          <div className='col-12 col-lg-6 text-lg-right mt-2 mt-lg-0'>
            <CSVImporter
              csrfToken={csrfToken}
              team={team}
              importerKey={"04493a0b-e5f8-41ea-a4dd-a18f8c203e3b"}
              type={"CSVImportRows::TourDate"}
              additionalParams={{ tour_id: tour.id }}
              onClose={
                () => {
                  toast.success("CSV uploaded successfully. Please check back in a few minutes to see the results.", {
                    position: toast.POSITION.TOP_CENTER,
                    draggable: false,
                    closeOnClick: false,
                    autoClose: 5000,
                    hideProgressBar: true
                  });
                }
              }
              renderAnchor={(openModal) => (
                <a href="#"
                   style={{fontWeight: '600'}}
                   onClick={openModal}>
                  Switch to CSV Upload
                </a>
              )}
            />
          </div>
        </div>
      </div>
      <form onSubmit={(e) => {
        e.preventDefault();

        if (!canSaveTourDate) {
          return;
        }

        const submitter = e.nativeEvent.submitter;
        const action = submitter.name;

        const callback = (data) => {
          if (action === 'save_and_add') {
            setTourDate({});
            setSupportArtists([]);
          } else if (action === 'save') {
            setTourDate(null);
          }
        }

        if (tourDate.id) {
          updateTourDate(tourDate, callback);
        } else {
          createTourDate(tourDate, callback);
        }
      }}>
        <p style={{fontSize: '16px', fontWeight: '600', marginBottom: '25px'}}>
          Event Info
        </p>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12 col-md-4">
            <label 
              htmlFor="tour-date-name"
              style={{
                fontSize: '14px',
                fontWeight: '600',
              }}
            >
              Event name<span style={{color: "#1982C4"}}>*</span>
            </label>
          </div>
          <div className="col-12 col-md-8">
            <input 
              type="text"
              className="form-control"
              placeholder="Event name"
              style={{
                "border": "1px solid #D5D7DA",
              }}
              value={tourDate.name || ""}
              onChange={(e) => {
                setTourDate({...tourDate, name: e.target.value});
              }}
              id="tour-date-name" 
            />
          </div>
        </div>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12 col-md-4">
            <label 
              htmlFor="tour-date-date" 
              style={{fontSize: '14px', fontWeight: '600'}}
            >
              Event date<span style={{color: "#1982C4"}}>*</span>
            </label>
          </div>
          <div className="col-12 col-md-8">
            <Flatpickr
              className="form-control"
              id="tour-date-date"
              style={{ border: "1px solid #D5D7DA" }}
              value={tourDate.event_on || ""}
              onClose={([date]) => {
                const updates = { ...tourDate, event_on: date };
                if (date) {
                  const endAt = new Date(date);
                  endAt.setHours(20, 0, 0, 0);
                  if (!tourDate.presale_end_at) updates.presale_end_at = endAt;
                  if (!tourDate.public_on_sale_end_at) updates.public_on_sale_end_at = new Date(endAt);
                  if (!tourDate.vip_end_at) updates.vip_end_at = new Date(endAt);
                }
                setTourDate(updates);
              }}
              placeholder="Enter date"
              options={{
                dateFormat: "F j, Y",
                allowInput: false
              }}
            />
          </div>
        </div>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12 col-md-4">
            <label 
              htmlFor="tour-date-venue-ownership" 
              style={{fontSize: '14px', fontWeight: '600'}}
            >
              Event venue<span style={{color: "#1982C4"}}>*</span>
            </label>
          </div>
          <div className="col-12 col-md-8">
            {isCreatingVenueOwnership ? (
              <div className='card border-0'
                    style={{
                      borderRadius: '8px',
                      backgroundColor: '#FAFAFA',
                      marginBottom: '5px'
                    }}>
                <div className='card-body'
                      style={{padding: '8px 16px', fontSize: '14px'}}>
                  <div className="text-center py-3">
                    <img src="/uploading-loading.gif"
                          style={{width: "18px"}} />
                  </div>
                </div>
              </div>
            ) : newVenue !== null ? (
              <div className='card border-0'
                    style={{
                      borderRadius: '8px',
                      backgroundColor: '#FAFAFA',
                      marginBottom: '5px'
                    }}>
                <div className='card-body'
                      style={{padding: '8px 16px', fontSize: '14px'}}>
                  <div className='form-row'>
                    <div className='col-12'>
                      <div className='form-group'>
                        <input type="text"
                                className="form-control"
                                style={{border: '1px solid #D5D7DA'}}
                                value={newVenue.name || ""}
                                onChange={(e) => setNewVenue({...newVenue, name: e.target.value})}
                                placeholder='Venue name' />
                      </div>
                    </div>
                    <div className='col-12'>
                      <div className='form-group'>
                        <input type="text"
                                className="form-control"
                                style={{border: '1px solid #D5D7DA'}}
                                value={newVenue.address1 || ""}
                                onChange={(e) => setNewVenue({...newVenue, address1: e.target.value})}
                                placeholder='Address' />
                      </div>
                    </div>
                    <div className='col-6'>
                      <div className='form-group'>
                        <input type="text"
                                className="form-control"
                                style={{border: '1px solid #D5D7DA'}}
                                value={newVenue.city || ""}
                                onChange={(e) => setNewVenue({...newVenue, city: e.target.value})}
                                placeholder='City' />
                      </div>
                    </div>
                    <div className='col-6'>
                      <div className='form-group'>
                        <input type="text"
                                className="form-control"
                                style={{border: '1px solid #D5D7DA'}}
                                value={newVenue.state || ""}
                                onChange={(e) => setNewVenue({...newVenue, state: e.target.value})}
                                placeholder='State' />
                      </div>
                    </div>
                    <div className='col-6'>
                      <div className='form-group'>
                        <input type="text"
                                className="form-control"
                                style={{border: '1px solid #D5D7DA'}}
                                value={newVenue.zip || ""}
                                onChange={(e) => setNewVenue({...newVenue, zip: e.target.value})}
                                placeholder='Zip' />
                      </div>
                    </div>
                    <div className='col-6'>
                      <div className='form-group'>
                        <input type="text"
                                className="form-control"
                                style={{border: '1px solid #D5D7DA'}}
                                value={newVenue.country || ""}
                                onChange={(e) => setNewVenue({...newVenue, country: e.target.value})}
                                placeholder='Country' />
                      </div>
                    </div>
                    <div className='col-12 text-right'>
                      <a href="#"
                          className='btn btn-sm btn-light'
                          onClick={
                            (e) => {
                              e.preventDefault();
                              setNewVenue(null);
                            }
                          }
                          style={{
                            fontWeight: '600',
                            borderRadius: '8px',
                            border: "1px solid #D5D7DA",
                            padding: '8px 12px'
                          }}>
                        Cancel
                      </a>
                      <a href="#"
                          className={'btn btn-sm btn-primary ' + (canSaveNewVenue ? '' : 'disabled')}
                          onClick={
                            (e) => {
                              e.preventDefault();

                              if (canSaveNewVenue) {
                                createVenue();
                              }
                            }
                          }
                          style={{
                            fontWeight: '600',
                            borderRadius: '8px',
                            border: "1px solid #D5D7DA",
                            padding: '8px 12px',
                            marginLeft: '16px'
                          }}>
                        {isCreatingVenue ? (
                          <React.Fragment>
                            <img src="/uploading-loading.gif"
                                 className="mr-1"
                                 style={{width: "16px"}} />
                            <strong>Creating Venue...</strong>
                          </React.Fragment>
                        ) : (
                          <strong>Create Venue</strong>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ) : tourDate.venue_ownership && tourDate.venue_ownership.name ? (
              <div className='card border-0'
                    style={{
                      borderRadius: '8px',
                      backgroundColor: '#FAFAFA',
                      marginBottom: '5px'
                    }}>
                <div className='card-body d-flex'
                      style={{padding: '8px 16px', fontSize: '14px'}}>
                  <div className='flex-grow-1'>
                    <p className='mb-0' style={{fontWeight: "600"}}>{tourDate.venue_ownership.name}</p>
                    <p className='mb-0' style={{marginTop: '-2px'}}>{tourDate.venue_ownership.address1}</p>
                    {tourDate.venue_ownership.address2 && (
                      <p className='mb-0' style={{marginTop: '-2px'}}>{tourDate.venue_ownership.address2}</p>
                    )}
                    <p className='mb-0' style={{marginTop: '-2px'}}>
                      {tourDate.venue_ownership.city}, {tourDate.venue_ownership.state_code_or_name} {tourDate.venue_ownership.zip}{tourDate.venue_ownership.country_name ? `, ${tourDate.venue_ownership.country_name}` : ''}
                    </p>
                    {tourDate.venue_ownership.website && isValidUrl(tourDate.venue_ownership.website) && (
                      <p className='mb-0' style={{marginTop: '-2px'}}>
                        <a href={tourDate.venue_ownership.website} target="_blank" rel="noopener noreferrer">{tourDate.venue_ownership.website}</a>
                      </p>
                    )}
                  </div>
                  <div>
                    <a href="#"
                        className='text-muted'
                        onClick={
                          (e) => {
                            e.preventDefault();
                            setTourDate({...tourDate, venue_ownership: null, venue_ownership_id: null});
                          }
                        }>
                      <i className="fas fa-times" style={{fontSize: '16px'}}></i>
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              <AsyncCreatableSelect cacheOptions
                                    placeholder={"Enter Venue name"}
                                    styles={selectStyles}
                                    menuPortalTarget={document.querySelector('body')}
                                    defaultOptions
                                    id="tour-date-venue-ownership"
                                    formatCreateLabel={() => "Add new venue"}
                                    formatOptionLabel={formatVenueLabel}
                                    onCreateOption={
                                      (label) => {
                                        setNewVenue({name: label});
                                      }
                                    }
                                    onChange={
                                      (option) => {
                                        findOrCreateVenueOwnership(option);
                                      }
                                    }
                                    value={ null }
                                    loadOptions={
                                      (inputValue, callback) => debouncedFetch(inputValue, callback)
                                    }
                                    components={{
                                      MenuList: (props) => (
                                        <CustomMenuList
                                          {...props}
                                          selectProps={{
                                            ...props.selectProps,
                                            onCreateOption: (label) => {
                                              setNewVenue({name: label});
                                            }
                                          }}
                                        />
                                      )
                                    }} />
            )}
          </div>
        </div>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12 col-md-4">
            <label style={{
                fontSize: '14px',
                fontWeight: '600',
              }}>
              Support <i className="fa fa-question-circle" 
                        style={{color: '#6c757d', marginLeft: '4px'}} 
                        title="Add support artists for this event"></i>
            </label>
          </div>
          <div className="col-12 col-md-8">
            <ArtistChipsField
              id="tour-date-support-artists"
              value={supportArtists}
              addLabel="Add support artist"
              teamId={team.id}
              onChange={setSupportArtists}
            />
          </div>
        </div>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12">
            <a href="#"
                style={{
                  color: "#136395",
                  fontWeight: "600",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setShowAdditionalSettings(!showAdditionalSettings);
                }}>
              Additional Settings<span style={{marginLeft: '10px'}}>{showAdditionalSettings ? <i className="far fa-angle-up"></i> : <i className="far fa-angle-down"></i>}</span>
            </a>
          </div>
        </div>
        {showAdditionalSettings && (
          <>
            <div className="form-row" style={{marginBottom: '20px'}}>
              <div className="col-12 col-md-4">
                <label 
                  htmlFor="tour-date-announce" 
                  style={{fontSize: '14px', fontWeight: '600'}}
                >
                  Announce Date/Time
                </label>
              </div>
              <div className="col-12 col-md-8">
                <Flatpickr
                  className="form-control"
                  id="tour-date-announce"
                  style={{ border: "1px solid #D5D7DA" }}
                  value={tourDate.announce_at || ""}
                  onClose={([date]) => {
                    const updates = { ...tourDate, announce_at: date };
                    if (date) {
                      const beginAt = new Date(date);
                      beginAt.setHours(10, 0, 0, 0);
                      if (!tourDate.presale_start_at) updates.presale_start_at = beginAt;
                      if (!tourDate.public_on_sale_start_at) updates.public_on_sale_start_at = new Date(beginAt);
                      if (!tourDate.vip_start_at) updates.vip_start_at = new Date(beginAt);
                    }
                    setTourDate(updates);
                  }}
                  placeholder="Enter date & time"
                  options={{
                    enableTime: true,
                    dateFormat: "M j, Y - h:iK",
                    time_24hr: false,
                    allowInput: false,
                    formatDate: (date) => formatDateTime(date)
                  }}
                />
              </div>
            </div>
            <div className="form-row" style={{marginBottom: '20px'}}>
              <div className="col-12 col-md-4">
                <label 
                  htmlFor="tour-date-state" 
                  style={{fontSize: '14px', fontWeight: '600'}}
                >
                  Event State
                </label>
              </div>
              <div className="col-12 col-md-8">
                <select 
                  className="form-control" 
                  id="tour-date-state"
                  style={{ border: "1px solid #D5D7DA" }}
                  value={tourDate.event_state || ""}
                  onChange={e => setTourDate({...tourDate, event_state: e.target.value})}
                >
                  <option value="">Select state</option>
                  <option value="Confirmed">Confirmed</option>
                  <option value="Tentative">Tentative</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Sold Out">Sold Out</option>
                </select>
              </div>
            </div>
            <p style={{fontSize: '16px', fontWeight: '600', marginBottom: '25px', marginTop: '20px'}}>
              Ticket Info
            </p>
            <div className="form-row" style={{marginBottom: '10px'}}>
              <div className="col-12 col-md-4">
                <label style={{fontSize: '14px', fontWeight: '600'}}>
                  Public on-sale
                </label>
              </div>
              <div className="col-12 col-md-8">
                <div className="form-row" style={{marginBottom: '10px'}}>
                  <div className="col-6 col-md-12 col-xl-6">
                    <label htmlFor="tour-date-public-on-sale-start" style={{fontSize: '14px', marginBottom: '6px'}}>
                      Begin Date/Time
                    </label>
                    <Flatpickr
                      className="form-control mr-2 mb-2"
                      id="tour-date-public-on-sale-start"
                      style={{border: '1px solid #D5D7DA'}}
                      placeholder="Enter date & time"
                      value={tourDate.public_on_sale_start_at || ""}
                      onClose={([date]) => setTourDate({
                        ...tourDate,
                        public_on_sale_start_at: date
                      })}
                      options={{
                        enableTime: true,
                        dateFormat: "M j, Y - h:iK",
                        time_24hr: false,
                        allowInput: false,
                        formatDate: (date) => formatDateTime(date)
                      }}
                    />
                  </div>
                  <div className="col-6 col-md-12 col-xl-6">
                    <label htmlFor="tour-date-public-on-sale-end" style={{fontSize: '14px', marginBottom: '6px'}}>
                      End Date/Time
                    </label>
                    <Flatpickr
                      className="form-control mr-2 mb-2"
                      id="tour-date-public-on-sale-end"
                      style={{border: '1px solid #D5D7DA'}}
                      placeholder="Enter date & time"
                      value={tourDate.public_on_sale_end_at || ""}
                      onClose={([date]) => setTourDate({
                        ...tourDate,
                        public_on_sale_end_at: date
                      })}
                      options={{
                        enableTime: true,
                        dateFormat: "M j, Y - h:iK",
                        time_24hr: false,
                        allowInput: false,
                        formatDate: (date) => formatDateTime(date)
                      }}
                    />
                  </div>
                </div>
                <div className="form-group" style={{marginBottom: '20px'}}>
                  <label htmlFor="tour-date-public-on-sale-url" style={{fontSize: '14px', marginBottom: '6px'}}>
                    URL
                  </label>
                  <input
                    type="text"
                    id="tour-date-public-on-sale-url"
                    className="form-control"
                    placeholder="Enter url"
                    style={{border: '1px solid #D5D7DA'}}
                    value={tourDate.public_on_sale_url || ""}
                    onChange={e => setTourDate({...tourDate, public_on_sale_url: e.target.value})}
                  />
                </div>
              </div>
            </div>
            <div className="form-row" style={{marginBottom: '10px'}}>
              <div className="col-12 col-md-4">
                <label style={{fontSize: '14px', fontWeight: '600'}}>Presale</label>
              </div>
              <div className="col-12 col-md-8">
                <div className="form-row" style={{marginBottom: '10px'}}>
                  <div className="col-6 col-md-12 col-xl-6">
                    <label htmlFor="tour-date-presale-begin" style={{fontSize: '14px', marginBottom: '6px'}}>
                      Begin Date/Time
                    </label>
                    <Flatpickr
                      className="form-control mr-2 mb-2"
                      id="tour-date-presale-begin"
                      style={{border: '1px solid #D5D7DA'}}
                      placeholder="Enter date & time"
                      value={tourDate.presale_start_at || ""}
                      onClose={([date]) => setTourDate({...tourDate, presale_start_at: date})}
                      options={{
                        enableTime: true,
                        dateFormat: "M j, Y - h:iK",
                        time_24hr: false,
                        allowInput: false,
                        formatDate: (date) => formatDateTime(date)
                      }}
                    />
                  </div>
                  <div className="col-6 col-md-12 col-xl-6">
                    <label htmlFor="tour-date-presale-end" style={{fontSize: '14px', marginBottom: '6px'}}>
                      End Date/Time
                    </label>
                    <Flatpickr
                      className="form-control mr-2 mb-2"
                      id="tour-date-presale-end"
                      style={{border: '1px solid #D5D7DA'}}
                      placeholder="Enter date & time"
                      value={tourDate.presale_end_at || ""}
                      onClose={([date]) => setTourDate({...tourDate, presale_end_at: date})}
                      options={{
                        enableTime: true,
                        dateFormat: "M j, Y - h:iK",
                        time_24hr: false,
                        allowInput: false,
                        formatDate: (date) => formatDateTime(date)
                      }}
                    />
                  </div>
                </div>
                <div className="form-group" style={{marginBottom: '20px'}}>
                  <label htmlFor="tour-date-presale-code" style={{fontSize: '14px', marginBottom: '6px'}}>
                    Code
                  </label>
                  <input
                    type="text"
                    id="tour-date-presale-code"
                    className="form-control"
                    placeholder="Enter presale code"
                    style={{border: '1px solid #D5D7DA'}}
                    value={tourDate.presale_code || ""}
                    onChange={e => setTourDate({...tourDate, presale_code: e.target.value})}
                  />
                </div>
                <div className="form-group" style={{marginBottom: '20px'}}>
                  <label htmlFor="tour-date-presale-url" style={{fontSize: '14px', marginBottom: '6px'}}>
                    URL
                  </label>
                  <input
                    type="text"
                    id="tour-date-presale-url"
                    className="form-control"
                    placeholder="Enter url"
                    style={{border: '1px solid #D5D7DA'}}
                    value={tourDate.presale_url || ""}
                    onChange={e => setTourDate({...tourDate, presale_url: e.target.value})}
                  />
                </div>
              </div>
            </div>
            <div className="form-row" style={{marginBottom: '20px'}}>
              <div className="col-12 col-md-4">
                <label
                  htmlFor="tour-date-lottery"
                  style={{fontSize: '14px', fontWeight: '600'}}
                >
                  Ticket Lottery
                </label>
              </div>
              <div className="col-12 col-md-8">
                <div style={{"border": "1px solid #D5D7DA", "borderRadius": "12px", "padding": "16px"}}>
                  <input
                    type="checkbox"
                    id="tour-date-lottery"
                    checked={!!tourDate.enable_lottery}
                    onChange={e => setTourDate({...tourDate, enable_lottery: e.target.checked})}
                  />
                  <label htmlFor="tour-date-lottery" style={{marginLeft: '8px', fontSize: '14px', marginBottom: '0px'}}>
                    Yes, enable lottery system
                  </label>
                </div>
              </div>
            </div>
            <div className="form-row" style={{marginBottom: '10px'}}>
              <div className="col-12 col-md-4">
                <label style={{fontSize: '14px', fontWeight: '600'}}>VIP</label>
              </div>
              <div className="col-12 col-md-8">
                <div className="form-row" style={{marginBottom: '10px'}}>
                  <div className="col-6 col-md-12 col-xl-6">
                    <label htmlFor="tour-date-vip-start" style={{fontSize: '14px', marginBottom: '6px'}}>
                      Begin Date/Time
                    </label>
                    <Flatpickr
                      className="form-control mr-2 mb-2"
                      id="tour-date-vip-start"
                      style={{border: '1px solid #D5D7DA'}}
                      placeholder="Enter date & time"
                      value={tourDate.vip_start_at || ""}
                      onClose={([date]) => setTourDate({...tourDate, vip_start_at: date})}
                      options={{
                        enableTime: true,
                        dateFormat: "M j, Y - h:iK",
                        time_24hr: false,
                        allowInput: false,
                        formatDate: (date) => formatDateTime(date)
                      }}
                    />
                  </div>
                  <div className="col-6 col-md-12 col-xl-6">
                    <label htmlFor="tour-date-vip-end" style={{fontSize: '14px', marginBottom: '6px'}}>
                      End Date/Time
                    </label>
                    <Flatpickr
                      className="form-control mr-2 mb-2"
                      id="tour-date-vip-end"
                      style={{border: '1px solid #D5D7DA'}}
                      placeholder="Enter date & time"
                      value={tourDate.vip_end_at || ""}
                      onClose={([date]) => setTourDate({...tourDate, vip_end_at: date})}
                      options={{
                        enableTime: true,
                        dateFormat: "M j, Y - h:iK",
                        time_24hr: false,
                        allowInput: false,
                        formatDate: (date) => formatDateTime(date)
                      }}
                    />
                  </div>
                </div>
                <div className="form-group" style={{marginBottom: '20px'}}>
                  <label htmlFor="tour-date-vip-url" style={{fontSize: '14px', marginBottom: '6px'}}>
                    URL
                  </label>
                  <input 
                    type="text" 
                    id="tour-date-vip-url"
                    className="form-control" 
                    placeholder="Enter url" 
                    style={{border: '1px solid #D5D7DA'}}
                    value={tourDate.vip_url || ""}
                    onChange={e => setTourDate({...tourDate, vip_url: e.target.value})}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12">
            <hr style={{
              borderTop: '1px solid #E9EAEB',
              marginTop: '5px',
              marginBottom: '20px'
            }} />
          </div>
        </div>
        <div className="form-row" style={{margin: '35px 0px 20px 0px'}}>
          <div className="col-12 d-flex justify-content-between align-items-center">
            <a 
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setTourDate(null);
              }}
            >
              Cancel
            </a>
            <div className='d-flex align-items-stretch flex-column text-right align-items-sm-center flex-sm-row align-items-md-stretch flex-md-column align-items-lg-center flex-lg-row'>
              {tourDate.id ? (
                <a href="#"
                  className="text-danger"
                  style={{marginBottom: '5px', marginLeft: '10px'}}
                  onClick={
                    (e) => {
                      e.preventDefault();

                      if(!window.confirm("Are you sure you want to delete this event?")) {
                        return;
                      }

                      deleteTourDate(tourDate);
                      setTourDate(null);
                    }
                  }>
                  Delete Event
                </a>
              ) : null}
              <button 
                type="submit"
                name="save_and_add"
                style={{fontSize: '14px', marginBottom: '5px', marginLeft: '10px'}}
                disabled={!canSaveTourDate}
                className="btn btn-outline-primary"
              >
                Save & Add Another
              </button>
              <button 
                type="submit"
                name="save"
                style={{fontSize: '14px', marginBottom: '5px', marginLeft: '10px'}}
                disabled={!canSaveTourDate}
                className="btn btn-primary"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
};

TourDateForm.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  tour: PropTypes.object.isRequired,
  tourDate: PropTypes.object.isRequired,
  setTourDate: PropTypes.func.isRequired,
  tourDates: PropTypes.array.isRequired,
  tourDatesChanged: PropTypes.func.isRequired,
  deleteTourDate: PropTypes.func.isRequired
};

export default TourDateForm;
